// third-party
import { format } from 'date-fns';

// date-fns throws RangeError on an invalid date, which takes the page down with it. Half-typed
// dates reach here routinely — a date picker reports every keystroke, so "12/" is an Invalid Date
// on its way to a valid one — so an unparseable value formats as the field's placeholder text.
const formatter = (pattern, fallback) => (textDate) => {
    if (!textDate || textDate.length === 0) {
        return fallback;
    }
    const date = new Date(textDate);
    if (Number.isNaN(date.getTime())) {
        return fallback;
    }
    return format(date, pattern);
};

const formatDate = formatter('MMMM d, yyyy', '<date not specified>');

const formatDateMMDDYY = formatter('MM/dd/yy', '');

const formatDateWithTime = formatter('M/d/yy h:mm aaa', '<unspecified>');

const formatDateLongTime = formatter('MMMM d, yyyy - h:mm aaa', '<unspecified>');

const formatDateLong = formatter('EEEE, MMMM d yyyy', '<date not specified>');

const formatDateMMYY = formatter('MMM, yyyy', '<date not specified>');

const dateToUTC = (localDate) => {
    if (!localDate) {
        return undefined;
    }
    // prettier-ignore
    const utcDate = new Date(localDate.getUTCFullYear(), localDate.getUTCMonth(), localDate.getUTCDate(), localDate.getUTCHours(), localDate.getUTCMinutes(), localDate.getUTCSeconds(), localDate.getUTCMilliseconds());
    return utcDate;
};

export { formatDate, formatDateWithTime, formatDateMMDDYY, formatDateLong, dateToUTC, formatDateMMYY, formatDateLongTime };
